import React, { useState, useEffect } from "react";

// v3.4.244 — صندوق جدول عريض: شريط تمرير أفقي علوي متزامن مع السفلي، وارتفاع محدود بالشاشة فيبقى الشريط السفلي ظاهرًا دائمًا،
// ورأس الجدول وصف الإجماليات لاصقان أثناء التمرير الرأسي
// v3.4.249 — مكوّن مشترك (كان محليًا في صفحة التحليل المالي) — يُستخدم في التحصيلات وقائمة العملاء المحتملين وكشف حجوزات دليلك
export default function ScrollSyncBox({ children, maxHeight = "calc(100vh - 150px)", headBg = "#f1f5f9" }) {
  const boxRef = React.useRef(null), topRef = React.useRef(null), syncing = React.useRef(false);
  const [w, setW] = useState(0);
  useEffect(() => {
    const el = boxRef.current; if (!el) return;
    const upd = () => setW(el.scrollWidth);
    upd();
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(upd) : null;
    if (ro) { ro.observe(el); const t = el.querySelector("table"); if (t) ro.observe(t); }
    window.addEventListener("resize", upd);
    return () => { if (ro) ro.disconnect(); window.removeEventListener("resize", upd); };
  });
  const sync = (from, to) => { if (syncing.current || !from || !to) return; syncing.current = true; to.scrollLeft = from.scrollLeft; syncing.current = false; };
  return (
    <div className="scroll-sync-box">
      <style>{`
        .scroll-sync-box thead th{position:sticky;top:0;z-index:3;background:${headBg}}
        .scroll-sync-box tfoot td{position:sticky;bottom:0;z-index:2;background:#f8fafc;box-shadow:0 -1px 0 #e2e8f0}
        .scroll-sync-box .ssb-top{overflow-x:auto;overflow-y:hidden;height:14px;margin-bottom:2px;border-radius:6px;background:#f8fafc}
        .scroll-sync-box .ssb-top::-webkit-scrollbar{height:10px}.scroll-sync-box .ssb-top::-webkit-scrollbar-thumb{background:#94a3b8;border-radius:6px}
      `}</style>
      <div ref={topRef} className="ssb-top" onScroll={() => sync(topRef.current, boxRef.current)} title="مرّر أفقيًا لرؤية بقية الأعمدة"><div style={{ width: w, height: 1 }} /></div>
      <div ref={boxRef} onScroll={() => sync(boxRef.current, topRef.current)} style={{ background: "#fff", border: "1px solid #e2e8f0", borderRadius: 10, overflow: "auto", maxHeight }}>
        {children}
      </div>
    </div>
  );
}
